import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c0cb5f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["textContent"]

import { TaskModel } from "@/components/tasks-kanban/models";
import { ListItemModel } from "../../../models";
import { computed, PropType } from "vue";
import { TaskCardItemWrapper } from "./";
import { formatDate } from "../services";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-card-date-create',
  props: {
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
},
  setup(__props) {

const props = __props;



/**Форматированная дата создания */
const dateCreate = computed(() => formatDate(props.task.DateCreate));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TaskCardItemWrapper), { element: __props.element }, {
    default: _withCtx(() => [
      (__props.task.DateCreate)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            textContent: _toDisplayString(dateCreate.value),
            class: "task-card-date-create"
          }, null, 8, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["element"]))
}
}

})